<template>
  <div class="container">
    <div class="boxtit">
      瀏覽及聯絡數據
    </div>
    <div class="firBox">
      <div class="chartbox">
        <div class="charttit">
          瀏覽及聯絡數據(最近30天) <br>每日結算時間= 00:00
        </div>
      </div>
      <div
        id="myChart"
        class="chart"
        :style="{ width: '100%', height: '500px' }"
      />
    </div>
    <div class="secBox">
      <div
        v-for="(item, index) in sumData"
        :key="index"
        :class="{ seriesBox: true, 'with-margin': index == sumData.length - 1 }"
      >
        <p class="titDiv">
          {{ item.title }}
        </p>
        <p class="couDiv">
          {{ item.count.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}
        </p>
      </div>
    </div>
    <div class="tableBox">
      <div class="btnBox">
        <el-button
          type="primary"
          class="excBtn"
          @click="downloadExcel"
        >
          按此下載Excel數據
        </el-button>
      </div>
      <div class="tableBoxe">
        <el-table
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
          :data="tableData"
          height="1483"
          style="width: 100%"
        >
          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :prop="column.prop"
            :label="column.label"
            :width="calcWidth('25%')"
            :align="column.align"
          >
            <template slot-scope="scope">
              {{ column.prop == 'time' ? scope.row[column.prop].substring(0, scope.row[column.prop].indexOf('T')) : scope.row[column.prop] }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/line');
require('echarts/lib/component/tooltip'); // tooltip组件
require('echarts/lib/component/title'); //  title组件
require('echarts/lib/component/legend'); // legend组件
require('echarts/lib/component/dataZoom'); // legend组件
export default {
    data() {
        return {
            tableData: [],
            sumData: [
                { title: '瀏覽人次總數', name: 'browseSumCount', count: '' },
                { title: '聯絡數總數', name: 'contactSumCount', count: '' },
                { title: 'WhatsApp總數', name: 'whatsAppSumCount', count: '' },
                { title: '電話總數', name: 'telSumCount', count: '' },
                { title: 'SMS總數', name: 'smsSumCount', count: '' }
            ],
            tableColumns: [
                { label: '日期', prop: 'time', width: 220, align: 'left' },
                { label: '單日新增瀏覽人次', prop: 'browseCount', width: 220, align: 'center' },
                { label: '單日新增聯絡數', prop: 'contactCount', width: 220, align: 'center' },
                { label: '單日新增WhatsApp', prop: 'whatsAppCount', width: 220, align: 'center' },
                { label: '單日新增電話', prop: 'telCount', width: 220, align: 'center' },
                { label: '單日新增SMS', prop: 'smsCount', width: 220, align: 'center' }
            ],
            isUseBrowseStandard :true,
            isUseBrowseStar :true,
            isUseBrowseSuper :true,
        };
    },
    async created(){
       let rescom = await this.axios.get(this.pub.getApi().GetCompanyCofig);
        if (rescom.data.code === 0 && rescom.data.result) {
            this.isUseBrowseStandard = rescom.data.result.isUseBrowseStandard
            this.isUseBrowseStar = rescom.data.result.isUseBrowseStar
            this.isUseBrowseSuper = rescom.data.result.isUseBrowseSuper
        }
        await this.axios.post(this.pub.getApi().SearchPropertyList, {
            keyString: this.$route.query.propertyId,
            pageCount: 20,
            pageIndex: 1,
        }).then(res => {
            if (res.data.code === 0 && res.data.result) {
                let topType = res.data.result.data[0].topType
                if(!((topType == 0 && this.isUseBrowseStandard) || (topType == 1 && this.isUseBrowseSuper) || (topType == 3 && this.isUseBrowseStar))){
                    this.$router.push({
                         name: this.pub.routeNameLists.PropertyIndex,
                    });
                }
            }else{
                console.log(res.data.code,"beforeRouteEnterss", res.data.result)
                this.$router.push({
                    name: this.pub.routeNameLists.PropertyIndex,
                });
            } 
        });
    },
    async mounted() {
        await this.getBroseTable();
        this.loadLine()
    },
    methods: {
        loadLine() {
            let conCount = this.tableData.map(item => item.contactCount)
            let broCount = this.tableData.map(item => item.browseCount)
            let hasData = false
            let allZeroC = conCount.every(function(element) {
                return element === 0;
            });
            let allZeroB = broCount.every(function(element) {
                return element === 0;
            });
            hasData = allZeroC && allZeroB
            let option = {
                title: {
                    text: '',
                    left: 10
                },
                grid: {
                    left: 40,
                    right: 20
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: '#ffffff',
                    extraCssText: 'box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);',
                    formatter: function (params, ticket, callback) {
                        var txt = '';
                        txt += '<span style="color:#333;">' + params[0].axisValue + '</span>';
                        for (var i = 0; i < params.length; i++) {
                            txt += '<br/>';
                            var item = params[i];
                            txt +='<span style="color:#989898;">'+ item.marker + ' ' + item.seriesName + '：' + item.data+ '</span>';
                        }
                        /** 针对tooltip中浏览人次在上且为蓝色标识*/
                        // for (var i = params.length-1; i >=0 ; i--) {
                        //     txt += '<br/>';
                        //     var item = params[i];
                        //     txt +='<span style="color:#989898;">'+ item.marker + ' ' + item.seriesName + '：' + item.data+ '</span>';
                        // }
                        return txt;
                    }
                },
                
                xAxis: [
                    {
                        data: this.getDataX(),
                        axisTick: {
                            show: true, 
                            inside: true, 
                            alignWithLabel: true,
                        },
                    }
                ],
                yAxis: {
                    type:'value',
                    max:hasData?6:null,
                    min:0,
                    minInterval: 1,
                    axisTick: {
                        show: false, 
                    },
                },
                dataZoom: [
                    {   
                        type: 'slider',
                        showDetail: true,
                        zoomLock: false,
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        fillerColor: 'rgba(160,167,192, 0.2)',
                        dataBackground: {
                            lineStyle: {
                                color: 'rgba(255, 0, 0)'
                            },
                            areaStyle: {
                                color: 'rgba(255, 255, 255, 0)'
                            }
                        },
                        selectedDataBackground: {
                            lineStyle: {
                                color: '#ff4655'
                            }
                        },
                        handleStyle: {
                            color: '#A0A7C0'
                        }
                    }
                ],
                series: [
                   
                    {
                        name: '單日新增聯絡數',
                        type: 'line',
                        data: conCount,
                        itemStyle: {
                            color: '#FF4C56'
                        }
                    },
                    {
                        name: '單日新增瀏覽人次',
                        type: 'line',
                        data: broCount,
                        itemStyle: {
                            color: '#0090C8'
                        }
                    },  
                    
                ],
                animation: false
            };
         
            this.myChartOne = echarts.init(document.getElementById('myChart'));
            this.myChartOne.setOption(option);
        },
        getDataX() {
            let result = [];
            let list = this.tableData;
            for (let i = 0; i < list.length; i++) {
                const date = new Date(list[i].time);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                result.push(day + '/' + month + '/' + year);

            }
            return result;
        },
        downloadExcel() {
            const loading = this.$loading({
                lock: true,
                text: '正在努力導出數據,大約會耗時幾分鐘，請不要關閉當前網頁',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if (!this.tableData) {return;}
            let arr = [];
            this.tableData.map(item => {
                let obj = {};
                obj.日期 = item.time.substring(0, item.time.indexOf('T'));
                obj.單日新增瀏覽人次 = item.browseCount;
                obj.單日新增聯絡數 = item.contactCount;
                obj.單日新增WhatsApp = item.whatsAppCount;
                obj.單日新增電話 = item.telCount;
                obj.單日新增SMS = item.smsCount;
                arr.push(obj);
            });
            var header = { header: ['日期', '單日新增瀏覽人次', '單日新增聯絡數', '單日新增WhatsApp', '單日新增電話', '單日新增SMS'] };
            const ws = XLSX.utils.json_to_sheet(arr, header);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '瀏覽數據');
            XLSX.writeFile(wb, '瀏覽數據.xlsx');
            loading.close();
        },
        calcWidth(width) {
            return `calc(${width} - 20px)`;
        },
        getBroseTable() {
            return new Promise((suc,err)=>{
                this.axios
                    .post(this.pub.getApi().GetPropertyBrowse, {
                        propertyID: this.$route.query.propertyId
                    })
                    .then(res => {
                        if (res.data.code == 0 && res.data.result) {
                            for (let i = 0; i < this.sumData.length; i++) {
                                this.sumData[i].count = res.data.result[this.sumData[i].name];
                            }
                            this.tableData = res.data.result.browseData;
                            suc()
                        }
                    });
            })
        }
    }
};
</script>

<style scoped lang="less">
 ::v-deep .el-table thead th:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  ::v-deep .el-table thead th:nth-last-child(2) {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px ;
  }
// 隐藏table表格 侧边滚动条
::v-deep .el-table__body-wrapper {
    &::-webkit-scrollbar {
        width: 0px;
        background: #022278;
        border: none;
    }
    &::-webkit-scrollbar-track {
        border: none;
    }
}
::v-deep .el-table th.gutter {
    display: none;
    width: 0;
}
::v-deep .el-table colgroup col[name='gutter'] {
    display: none;
    width: 0;
}
::v-deep .el-table__body {
    width: 100% !important;
}
.container {
    .boxtit {
        text-align: left;
        font-size: 24px;
        color: #171725;
        margin-bottom: 20px;
    }
    .firBox {
        background-color: #ffffff;
        border-radius: 10px;
        margin-bottom: 20px;
        padding-top: 20px;
        text-align: left;
        .chartbox {
            margin-left: 33px;
            font-size: 14px;
            color: #171725;
        }
    }
    .secBox {
        vertical-align: top;
        text-align: left;
        .seriesBox {
            display: inline-block;
            width: 14%;
            border-radius: 10px;
            background-color: #ffffff;
            padding-top: 30px;
            padding-left: 22px;
            text-align: left;
            margin-right: 40px;
            vertical-align: bottom;
            min-height: 130px;
            max-height: 230px;
            .titDiv {
                font-size: 24px;
                color: #44444f;
            }
            .couDiv {
                margin-top: 10px;
                font-size: 36px;
                color: #171725;
            }
        }
        .with-margin {
            margin-right: 0;
        }
    }
    .tableBox {
        margin-top: 20px;
        padding-bottom:20px;
        background-color: #f3f3f5;
        .btnBox {
            text-align: left;
            .excBtn {
                height: 38px;
                border-radius: 8px;
                margin-bottom: 10px;
            }
        }
        .tableBoxe {
            background-color: #ffffff;
            padding: 20px;
            border-radius: 10px;
        }
    }
}
</style>
